import React from "react";
import { CustomSelectInputProps } from "./type";
import "./style.scss";
import Select from "react-select";

/**
 * Yeni nesil seçim alanı. Üstte net etiket + temiz react-select.
 * (Eski floating FormGroup/Control sarmalayıcı hack'i atıldı.)
 */
const CustomSelectInput = ({
  labelKey,
  valueKey,
  options,
  disabled,
  className = "",
  label,
  placeholder,
  isMulti,
  placement,
  labelProps,
  error,
  name,
  value,
  touched,
  onChange,
  renderValue,
}: CustomSelectInputProps) => {
  const invalid = !!(error && touched);
  return (
    <div className={"m-field " + className}>
      {label && (
        <label className="m-field__label" {...labelProps}>
          {label}
        </label>
      )}
      <Select
        classNamePrefix="mselect"
        className={"m-rselect" + (invalid ? " is-invalid" : "")}
        value={
          isMulti
            ? options.filter((a) => (value || []).some((y: any) => y === a[valueKey]))
            : options[options.findIndex((x) => x[valueKey] === value)] ?? null
        }
        menuPlacement={placement as any}
        isDisabled={disabled}
        placeholder={placeholder}
        isSearchable={true}
        isClearable={true}
        onChange={(a: any) => {
          if (a === null) {
            if (isMulti) onChange([], []);
            else onChange(undefined, undefined);
          } else {
            if (isMulti)
              onChange(
                a.map((y: any) => y[valueKey]),
                a
              );
            else onChange(a[valueKey], a);
          }
        }}
        isMulti={isMulti}
        closeMenuOnSelect={isMulti ? false : true}
        menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
        styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
        getOptionLabel={(opt: any) =>
          renderValue ? renderValue(opt[labelKey]) : opt[labelKey]
        }
        getOptionValue={(opt: any) => opt[valueKey]}
        options={options}
      />
      {invalid && <div className="m-field__error">{error}</div>}
    </div>
  );
};
export default CustomSelectInput;
